import { renderDiscountImportantPopup } from 'components/Discount/func';
import ButtonCommon from 'components/common/ButtonCommon';
import BodySectionHeader from 'components/fx/components/BodySectionHeader';
import { IS_PAYTO_CONFIG_DISABLE } from 'config';
import {
  ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME,
  DESKTOP_MIN_WIDTH,
  METHOD_PAYTO,
  SCREEN_ID_EXCHANGE_STEP_3,
} from 'constants';
import {
  FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME,
  RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD,
} from 'constants/fx';
import withLoadPaytoAccountsAgreementInitial from 'features/to/HOCs/payment/withLoadPaytoAccountsAgreementInitial';
import withPaymentMethodAutoSelect from 'features/to/HOCs/payment/withPaymentMethodAutoSelect';
import PaytoAccountsAgreement from 'features/to/components/payment/payto/PaytoAccountsAgreement';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useAutoShowEventModal from 'hooks/useAutoShowEventModal';
import useCommonStore from 'hooks/useCommonStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import useScrollIntoViewDelay from 'hooks/useScrollIntoViewDelay';
import { isArray, isEmpty } from 'lodash';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import CalculatorForm from '../CalculatorForm';
import PaymentMethodsGrid from '../PaymentMethodsGrid';

const PaymentMethodsGridExt = withLoadPaytoAccountsAgreementInitial(
  withPaymentMethodAutoSelect(PaymentMethodsGrid)
);

const initialFormField = RESET_FX_ADD_TRANSACTION_PAYMENT_METHOD;

const SCREEN_ID = SCREEN_ID_EXCHANGE_STEP_3;

const PaymentMethod = ({
  handleOnToggleCancelPopup,
  handleOnViewPickupLocation,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const [information, setInformation] = useState(initialFormField);
  const [validation, setValidation] = useState(initialFormField);
  const [informationChangeBackup, setInformationChangeBackup] = useState(null);
  const [isOpenDiscountImportantPopup, setOpenDiscountImportantPopup] =
    useState(false);

  const { paytoAccountInformation, paytoAccountsAgreement } = useCommonStore();
  const { isUpdateTran, getTitleBodySection, getPayLimitRanger, isFxAsGuest } =
    useFxAddTransaction();
  const {
    addTransactionCurrentStep: currentStep,
    setAddTransactionCurrentStep,
    paymentMethodName,
    setPaymentMethod,
    getPaymentAmountLimit,
    isPaytoBlocked,
  } = useFxFormAddTransactionStore();

  const { resetPaytoAccountsAgreement } = usePaytoStore();

  const isNextDisabled = isEmpty(paymentMethodName);

  const isPaymentMethodDisabled = (paymentMethodName) => {
    const payLimit = getPayLimitRanger()?.[paymentMethodName];
    const amountLimit = getPaymentAmountLimit();

    if (payLimit?.payLimitMax && amountLimit > payLimit?.payLimitMax)
      return {
        ...payLimit,
        amountLimit,
      };

    return false;
  };

  // scroll to calculator form
  const validRef = useRef(null);
  useScrollIntoViewDelay(validRef, validRef, []);

  const handleOnClickDiscountImportantPopup = () => {
    if (informationChangeBackup) {
      setInformation(informationChangeBackup);

      const newPaymentMethod = {
        ...paymentStore,
        ...informationChangeBackup,
        discountsAvailable: [],
        discountsInactive: [],
        discountApplied: null,
      };
      setPaymentMethod(newPaymentMethod);

      setInformationChangeBackup(null);

      setValidation(initialFormField);
    }
  };

  const handleOnCloseDiscountImportantPopup = () => {
    setInformationChangeBackup(null);
  };

  const handleBackStep = () => {
    setAddTransactionCurrentStep(currentStep - 1);

    const isCachePaymentMethod = paymentMethodName !== '';
    if (isCachePaymentMethod) {
      // setPaymentMethod(information);
    }

    if (paymentMethodName === METHOD_PAYTO) {
      resetPaytoAccountsAgreement(false);
    }
  };
  const handleNextStep = () => {
    let newValidation = { ...validation };

    const isPaymentMethodSelectedInvalid = isEmpty(paymentMethodName);
    const isPayLimit = isPaymentMethodDisabled(paymentMethodName);
    const isAllowSubmit = !isPaymentMethodSelectedInvalid;

    if (isPaymentMethodSelectedInvalid || isPayLimit) {
      newValidation = {
        ...newValidation,
        [FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]:
          'fx_add_transaction_choose_payment_method',
      };
      setValidation(newValidation);
      return;
    } else {
      delete newValidation?.[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME];
    }

    if (
      paymentMethodName === METHOD_PAYTO &&
      isEmpty(paytoAccountInformation)
    ) {
      newValidation = {
        ...newValidation,
        [ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME]: 'required',
      };
      setValidation(newValidation);
      return;
    } else {
      delete newValidation?.[ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME];
    }

    console.log(
      `⭐ PAYMENT_METHOD 👉 handleNextStep ➡️ newInformation ↩`,
      information
    );
    console.log(
      `⭐ PAYMENT_METHOD 👉 handleNextStep ➡️ newValidation ↩`,
      newValidation
    );

    if (isAllowSubmit) {
      setAddTransactionCurrentStep(currentStep + 1);
    }

    setValidation(newValidation);
  };
  const renderCalculatorFormMobile = () => {
    if (isDesktop) return null;
    return (
      <CalculatorForm
        ref={validRef}
        isCalculatorFormAccordion={true}
        handleOnViewPickupLocation={handleOnViewPickupLocation}
      />
    );
  };
  const renderActionsButton = () => {
    return (
      <NextWrap>
        {renderCalculatorFormMobile()}
        <ActionWrapper>
          <ButtonCommonWrap>
            <ButtonCommon
              value={t('button_back')}
              onClick={handleBackStep}
              styles={{
                margin: '0px',
                width: !isDesktop && '100%',
              }}
              color="var(--ds-c-blue)"
              background="var(--ds-c-white)"
              borderNameVariable={isDesktop && '--border-filter'}
              isFill={false}
            />
          </ButtonCommonWrap>
          <ButtonCommon
            value={t('button_confirm')}
            color="var(--c-primary)"
            background="var(--bg-primary)"
            isFill={true}
            styles={{
              margin: '0px',
              width: isDesktop ? '150px' : '50%',
            }}
            onClick={handleNextStep}
            isDisabled={false}
            isUseKeyDown={!isNextDisabled}
          />
        </ActionWrapper>
      </NextWrap>
    );
  };

  useAutoShowEventModal({
    screenId: SCREEN_ID,
    params: [],
    modalStyles: {},
    modalOptions: {},
  });

  const checkPaymentMethodItemDisabled = (paymentMethod) => {
    if (paymentMethod === METHOD_PAYTO)
      return (
        (isArray(paytoAccountsAgreement) &&
          paytoAccountsAgreement?.some(
            (accountAgreement) => accountAgreement?.blocked
          )) ||
        isPaymentMethodDisabled(paymentMethod)
      );
    return isPaymentMethodDisabled(paymentMethod);
  };
  const renderPaytoAccountAgreement = () => {
    if (checkPaymentMethodItemDisabled(paymentMethodName)) return null;
    if (isPaytoBlocked) return null;
    return <PaytoAccountsAgreement validation={validation} />;
  };

  const renderPaymentMethodsGrid = () => {
    if (IS_PAYTO_CONFIG_DISABLE || isFxAsGuest) {
      return (
        <PaymentMethodsGrid
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
          informationChangeBackup={informationChangeBackup}
          setInformationChangeBackup={setInformationChangeBackup}
          setOpenDiscountImportantPopup={setOpenDiscountImportantPopup}
          isSelectRequired={validation[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
          checkPaymentMethodItemDisabled={checkPaymentMethodItemDisabled}
        />
      );
    }
    return (
      <PaymentMethodsGridExt
        information={information}
        setInformation={setInformation}
        validation={validation}
        setValidation={setValidation}
        informationChangeBackup={informationChangeBackup}
        setInformationChangeBackup={setInformationChangeBackup}
        setOpenDiscountImportantPopup={setOpenDiscountImportantPopup}
        isSelectRequired={validation[FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME]}
        checkPaymentMethodItemDisabled={checkPaymentMethodItemDisabled}
      />
    );
  };

  return (
    <>
      {isOpenDiscountImportantPopup &&
        renderDiscountImportantPopup({
          t,
          isOpen: isOpenDiscountImportantPopup,
          setOpen: setOpenDiscountImportantPopup,
          paymentMethod: paymentMethodName,
          onCloseExt: handleOnCloseDiscountImportantPopup,
          onClickExt: handleOnClickDiscountImportantPopup,
          contentReplace:
            isUpdateTran &&
            t('discount_check_invalid_desc_3', {
              discountPaymentMethod: discountDetails?.paymentMethod,
              paymentMethodSelected:
                informationChangeBackup?.[
                  FX_ADD_TRANSACTION_PAYMENT_METHOD_NAME
                ],
            }),
        })}

      <BodySectionHeader
        titleBodySection={getTitleBodySection()}
        titleSection={t('add_transaction_title_payment_method')}
        CalculatorComponent={isDesktop && <CalculatorForm />}
        onToggleCancelPopup={handleOnToggleCancelPopup}
        onViewPickupLocation={handleOnViewPickupLocation}
      />
      <PaymentMethodStyled>
        {renderPaymentMethodsGrid()}
        {renderPaytoAccountAgreement()}
        {renderActionsButton()}
      </PaymentMethodStyled>
    </>
  );
};

const PaymentMethodStyled = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: -8px;
  padding-inline: 0px;
  padding-bottom: 204px;
  background: var(--ds-c-white);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 100%;
    margin-top: 0px;
    padding-inline: 0px;
    padding-bottom: unset;
  }
`;

export const NextWrap = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: fit-content;
  margin-inline: -16px;
  padding-inline: 0px;
  background: transparent;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    position: unset;
    margin-top: 40px;
    margin-bottom: 24px;
    margin-inline: unset;
    padding-inline: unset;
    width: 666px;
    height: fit-content;
    border-top: unset;
  }
`;
export const ActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 77px;
  width: 100%;
  background: var(--ds-c-white);
  border-top: 1px solid var(--ds-bg-2);
  padding-inline: 16px;
  margin: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 100%;
    height: 44px;
    border-top: unset;
    padding-inline: unset;
    margin: 0px;
  }
`;
export const ButtonCommonWrap = styled.div`
  width: 50%;
`;

export default PaymentMethod;
